<template>
  <div class="group-detail">
    <h1 class="common__main-title">Send Mail Detail</h1>
    <div v-if="mail">
      <div class="common__sub-title">Detail</div>
      <div class="content-wrapper">
        <div class="main-content">
          <div class="detail-table">
            <div>
              <div class="detail__item-title">Send date</div>
              <p class="detail__item">{{ mail.sendAt | ymdhm }}</p>
            </div>
            <div>
              <div class="detail__item-title">Subject</div>
              <p class="detail__item">{{ mail.subject }}</p>
            </div>
            <div>
              <div class="detail__item-title">Text</div>
              <p  class="detail__item" style="white-space:pre-wrap;">{{ mail.body }}</p>
            </div>
            <div>
              <div class="detail__item-title">Status</div>
              <p class="detail__item">{{ mail.status | mailStatus }}</p>
            </div>
            <div>
              <div class="detail__item-title">Target</div>
              <p class="detail__item">
                {{ mail.receivers && mail.receivers[0].type | targetType }}
              </p>
            </div>
            <div>
              <div class="detail__item-title">Receivers</div>
              <div class="detail__item mb-0">
                <div v-for="receiver of mail.receivers" :key="receiver.id" class="receiver">
                  <router-link v-if="receiver.type === 'student'"
                    :to="{ name: 'StudentDetail', params: { id: receiver.id } }">
                    {{ receiver.name }}
                  </router-link>
                  <router-link v-if="receiver.type === 'tutor'"
                    :to="{ name: 'TutorDetail', params: { id: receiver.id } }">
                    {{ receiver.name }}
                  </router-link>
                  <div v-if="receiver.type !== 'student' && receiver.type !== 'tutor'">
                    {{ receiver.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="mail" class="common__button-container">
      <b-button pill variant="secondary" :to="{ name:'Mails' }">
        Back
      </b-button>
      <b-button v-if="mail.status === 'unsent'" pill variant="danger" @click="cancel">
        Cancel
      </b-button>
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { Moment } from 'moment'
import Loading from '@/components/parts/modal/Loading.vue'
import {
  Mail,
  mailSendStatueType,
  MailSendStatuses,
  MailTargets,
  mailTargetType,
} from '@/store/mails/types'

@Component({
  components: {
    Loading,
  },
  filters: {
    ymdhm: (date: Moment): string => date.format('YYYY/MM/DD HH:mm'),
    mailStatus: (type: mailSendStatueType): string => MailSendStatuses[type],
    targetType: (type: mailTargetType): string => MailTargets[type],
  },
})
export default class MailDetail extends Vue {
  private isLoading: boolean = false

  private get mail(): Mail|undefined {
    return this.$store.getters.findMailById(this.$route.params.notificationId)
  }

  private created() {
    this.isLoading = true
    this.$store.dispatch('getMail', { notificationId: this.$route.params.notificationId })
      .then(() => { this.isLoading = false })
  }

  /**
   * 未送信のメールをキャンセルする
   */
  private async cancel() {
    if (this.isLoading) {
      return
    }

    if (await this.$bvModal.msgBoxConfirm('Are you sure undo send this mail?') !== true) {
      return
    }

    this.isLoading = true
    try {
      await this.$store.dispatch('cancelMail', { notificationId: this.$route.params.notificationId })
      this.isLoading = false
      await this.$bvModal.msgBoxOk('Success !')
      this.$router.go(0)
    } catch (error: any) {
      this.isLoading = false
      const message = (_.has(error, 'response')) ? error.response.data.message : error.message
      this.$bvModal.msgBoxOk(`Failed: ${message}`)
    }
  }
}
</script>

<style scoped>
.content-wrapper {
  background: #DDEAF6;
  padding: 20px 50px;
  margin-bottom:20px;
}

.main-content {
  background: #fff;
  padding: 30px 60px;
  border-radius: 20px;
  margin-bottom:20px;
}

.detail-table {
  width:100%;
}

.detail__item-title {
  line-height: 14px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  margin-bottom:10px;
}

.detail__item {
  line-height: 14px;
  font-size: 14px;
  margin-bottom:30px;
  padding-left:20px;
}

.receiver {
  margin-bottom:10px;
  align-items: center;
  display: flex;
}

.tutor-box {
  display: flex;
  align-items: center;
}

</style>
